export const hasPermissionsViolation = state => state.permissions.hasViolation;
export const getPermissionsHasGrowled = state => state.permissions.hasGrowled;
